/*
 * @Date: 2022-08-23 14:00:44
 * @LastEditors: kinfai
 * @Description: 路由conttext
 * @LastEditTime: 2022-08-31 10:32:59
 * @FilePath: \my-app\src\provide\route-context.js
 */
import { createContext } from "react";

export const RouteContext = createContext({
    path: 'home',
    goPage: () => { },
    // 客服信息
    csInfo: {
        id: 0,
        show: false
    },
    updateCsInfo: () => { },
    // 最后一条消息
    lastMsgInfo: {
        type: "text",
        value: "",
        messageId: 100,
        userName: "",
        avatar: ""
    },
    updateLastMsgInfo: () => { }
});
